import { divIcon } from "leaflet";

const getIcon = (iconName, pinFillColor) => {
  const iconShapes = {
    default: `<g transform="scale(0.7 0.7) translate(4.5 2.5)">
      <path d="M11.48 20v-6.26H8L13 4v6.26h3.35L11.48 20z" fill="white"/>
      </g>
      `,
    storage: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 199 199">
                        <defs>
                            <style>.cls-1-map-icon{fill:#fff;}.cls-1-map-icon,.cls-2-map-icon,.cls-3-map-icon{stroke-linejoin:round;stroke-width:7px;}.cls-3-map-icon{stroke:${pinFillColor};stroke-linejoin:round;stroke-width:7px;fill:none;stroke-linecap:round}
                        .cls-2-map-icon{stroke:none; fill:#fff}</style>
                        </defs>
                        <g transform="scale(0.55, 0.55) translate(80 20)">
                        <rect class="cls-1-map-icon" x="23.23" y="57.5" width="155.04" height="92" style="stroke:${pinFillColor}"/>
                        <rect class="cls-2-map-icon" x="42.5" y="43.5" width="31" height="14" />
                        <rect class="cls-2-map-icon" x="127.5" y="43.5" width="31" height="14" />
                        <rect class="cls-1-map-icon" x="15.5" y="159" width="170.5" height="6" style="stroke:#fff;stroke-linejoin:round;stroke-width:7px;fill:none;stroke-linecap:round"/>
                        <line  class="cls-3-map-icon"x1="154.5" y1="85.5" x2="130.5" y2="85.5" />
                        <line class="cls-3-map-icon" x1="69.5" y1="85.5" x2="45.5" y2="85.5" />
                        <line class="cls-3-map-icon" x1="142.5" y1="97.5" x2="142.5" y2="73.5" />
                        </g>
                      </svg>`,
    thermal: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190 230">
                        <defs>
                          <style>
                            .cls-1-thermal-map-icon {
                              fill: ${pinFillColor};
                              stroke: #fff;
                              stroke-miterlimit: 10;
                              stroke-width: 10px;
                            }
                            .cls-1-thermal;
                          </style>
                        </defs>
                        <g transform="scale(0.6 0.6) translate(60 30)">
                          <path
                            class="cls-1-thermal-map-icon"
                            d="M82.46,101.79v17l41-17.62v17.67l40-17.7v80.76c-.8,0-1.58.13-2.36.13q-41.69,0-83.39,0c-1.91,0-2.66-.55-2.75-2.43-.4-9-.87-18.06-1.32-27.09q-1-20.09-2-40.19c0-.3,0-.59,0-.89-.25-5.26-.06-5.56,4.9-7.48C78.34,103.3,80.2,102.63,82.46,101.79Zm41.1,46.09h24.16V137.15H123.57Zm-12.63-10.66H86.65v10.66h24.29ZM37.88,182h34L66.49,61.77H43.69ZM68.11,42.14c3-.18,6.08-.2,9.1-.48,8.51-.77,15.33-4.35,19.36-12.21a17.73,17.73,0,0,0,1.76-10.37,62,62,0,0,1-3.82,5.08c-3.39,3.65-7.93,5.08-12.63,6-5.74,1.13-11.53,2-17.26,3.2-6.22,1.29-10.18,5.22-12.06,11.21a14.53,14.53,0,0,0,.85,11.1C54.94,46.61,59.41,42.65,68.11,42.14Zm79.62,105.75V137.15H123.57v10.73ZM86.65,137.22v10.66h24.29V137.22Z"
                          />
                        </g>
                      </svg>`,
    solar: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 199 199">
            <defs>
                <style>
                    .cls-1-pv-icon{fill:#fff;}.cls-1-pv-icon,
                    .cls-2-pv-icon{stroke:#fff;stroke-linejoin:round;stroke-width:7px;}.cls-2-pv-icon{fill:none;},
                    .cls-3-pv-icon{fill:#fff;}.cls-3-pv-icon{fill:#fff;},
                </style>
            </defs>
            <g transform="scale(0.6 0.6) translate(65 20)">
                <rect class="cls-1-pv-icon" x="63.5" y="149.5" width="72" height="6"/>
                <polygon class="cls-2-pv-icon" points="169.25 119.5 29.75 119.5 47.08 57.5 151.92 57.5 169.25 119.5"/>
                <polygon class="cls-3-pv-icon" points="62.12 75.84 49.05 75.84 51.75 64.91 64.12 64.91 62.12 75.84"/>
                <polygon class="cls-3-pv-icon" points="79.64 76.29 66.54 76.29 68.31 65.31 80.71 65.31 79.64 76.29"/>
                <polygon class="cls-3-pv-icon" points="97.25 76.29 84.15 76.29 84.97 65.31 97.37 65.31 97.25 76.29"/>
                <polygon class="cls-3-pv-icon" points="114.85 76.29 101.75 76.29 101.63 65.31 114.03 65.31 114.85 76.29"/>
                <polygon class="cls-3-pv-icon" points="132.46 76.29 119.36 76.29 118.29 65.31 130.69 65.31 132.46 76.29"/>
                <polygon class="cls-3-pv-icon" points="150.06 76.29 136.96 76.29 134.95 65.31 147.35 65.31 150.06 76.29"/>
                <polygon class="cls-3-pv-icon" points="59.32 91.12 45.27 91.12 48.38 78.54 61.63 78.54 59.32 91.12"/>
                <polygon class="cls-3-pv-icon" points="78.15 91.63 64.07 91.63 66.11 79 79.38 79 78.15 91.63"/>
                <polygon class="cls-3-pv-icon" points="97.08 91.63 82.99 91.63 83.94 79 97.22 79 97.08 91.63"/>
                <polygon class="cls-3-pv-icon" points="116.01 91.63 101.92 91.63 101.78 79 115.06 79 116.01 91.63"/>
                <polygon class="cls-3-pv-icon" points="134.93 91.63 120.85 91.63 119.62 79 132.9 79 134.93 91.63"/>
                <polygon class="cls-3-pv-icon" points="153.86 91.63 139.77 91.63 137.46 79 150.73 79 153.86 91.63"/>
                <polygon class="cls-3-pv-icon" points="56.07 108.87 40.88 108.87 44.5 94.24 58.75 94.24 56.07 108.87"/>
                <polygon class="cls-3-pv-icon" points="76.42 109.47 61.19 109.47 63.56 94.77 77.85 94.77 76.42 109.47"/>
                <polygon class="cls-3-pv-icon" points="96.88 109.47 81.65 109.47 82.76 94.77 97.05 94.77 96.88 109.47"/>
                <polygon class="cls-3-pv-icon" points="117.35 109.47 102.12 109.47 101.95 94.77 116.24 94.77 117.35 109.47"/>
                <polygon class="cls-3-pv-icon" points="137.81 109.47 122.58 109.47 121.15 94.77 135.44 94.77 137.81 109.47"/>
                <polygon class="cls-3-pv-icon" points="158.27 109.47 143.04 109.47 140.35 94.77 154.63 94.77 158.27 109.47"/>
                <rect class="cls-3-pv-icon" x="80.5" y="119" width="38" height="30"/>
            </g>
        </svg>`,
    wind: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="-2 2 28 24">
                <defs>
                      <style>
                        .cls-1-wind-map-icon{fill: #fff;stroke: #fff;stroke-miterlimit: 10;stroke-width: 0px;}
                      </style>
                    </defs>
                <g transform="scale(0.7 0.7) translate(5 4)">
                <path class="cls-1-wind-map-icon" d="M13.33,11.67L16.21,14.58C17.62,13.16 16.21,11.75 16.21,11.75L14.72,10.24C14.9,9.86 15,9.44 15,9C15,7.95 14.46,7.03 13.64,6.5L15,2.11C13.09,1.53 12.5,3.44 12.5,3.44L11.69,6.03C10.46,6.16 9.46,7 9.13,8.18L4.67,9.63C5.31,11.53 7.2,10.9 7.2,10.9L9.27,10.23C9.61,10.97 10.23,11.54 11,11.82V19C11,19 9,19 9,21C9,21.5 9,21.81 9,22H15V21C15,21 15,19 13,19V11.82C13.12,11.78 13.23,11.72 13.33,11.67M10.5,9A1.5,1.5 0 0,1 12,7.5A1.5,1.5 0 0,1 13.5,9A1.5,1.5 0 0,1 12,10.5A1.5,1.5 0 0,1 10.5,9Z" />
                </g>
                </svg>`,
    hydro: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 220">
              <defs>
                  <style>
                    .cls-1-hydro-map-icon{fill: none;stroke: #fff;stroke-miterlimit: 10;stroke-width: 10px;}
                    .cls-2-hydro-map-icon{fill:#fff;}
                  </style>
                </defs>
                <g transform="scale(0.6 0.6) translate(80 30)">
                  <path
                    class="cls-1-hydro-map-icon"
                    d="M188,137.35c-15.29,0-30.58-5.23-44-14.79-26.84,19-61.16,19-88,0-13.42,9.57-28.71,14.79-44,14.79"
                  />
                  <path
                    class="cls-1-hydro-map-icon"
                    d="M188,161.35c-15.29,0-30.58-5.23-44-14.79-26.84,19-61.16,19-88,0-13.42,9.57-28.71,14.79-44,14.79"
                  />
                  <path class="cls-2-hydro-map-icon" d="M80,25V68H92v34.5L120,56H104l16-31Z" />
                </g>
              </svg>`,
    geothermal: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.7 12.7">
                    <title>geothermal</title>
                    <defs>
                      <style>
                      .cls-1 {
                        fill: none;
                        stroke: #FFF;
                        stroke-miterlimit: 10;
                        stroke-width: 0.4px;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      }
                      .cls-2 {
                        fill: #FFF;
                        stroke: #FFF;
                        stroke-width: 0.1;
                        stroke-linecap: round;
                      }
                      </style>
                    </defs>
                    <g id="Geothermal" transform="scale(0.5 0.5) translate(6 1.5)">
                      <path
                        class="cls-1"
                        d="M 7.3677264,0.92792642 4.1050173,5.3280939 6.0806028,5.358027 5.1526762,8.4710706 8.5051848,4.011037 H 6.3799339 Z"
                      />
                      <path
                        class="cls-1"
                        d="M 1.6713625,10.416723 V 4.9688966 c 0,0 0.02245,-0.5687292 0.6585284,-0.5687292 H 4.1386981 L 3.7495677,4.9165136 H 2.3598239 c 0,0 -0.1945651,0.014968 -0.1945651,0.1945654 v 5.253261"
                      />
                      <path
                        class="cls-1"
                        d="M 11.028638,10.416723 V 4.9688966 c 0,0 -0.02245,-0.5687292 -0.658528,-0.5687292 H 8.8755999 L 8.4715027,4.9165136 h 1.8686733 c 0,0 0.194566,0.014968 0.194566,0.1945654 v 5.253261"
                      />
                      <path
                        class="cls-2"
                        d="M 0.6136288,11.449415 V 8.2914719 H 1.1673914 V 10.82082 H 2.6939801 V 8.2615388 L 4.6535354,8.2765063 4.4739365,8.8003358 H 5.5825254 L 5.9657651,8.292082 h 4.0917599 v 2.558672 h 1.541556 V 8.3214058 h 0.523829 v 3.0980772 z"
                      />
                      <path
                        class="cls-2"
                        d="M 2.6790134,7.9023415 V 6.2260873 l 2.6939801,0 -0.5537624,1.6612876 z"
                      />
                      <path
                        class="cls-2"
                        d="M 6.2859534,7.9023415 7.4832779,6.2260873 h 2.6041811 l -0.01497,1.6612876 z"
                      />
                      <path
                        class="cls-2"
                        d="M 0.61266026,7.9033098 V 6.2251187 H 1.1683089 l 0.015017,1.6781921 z"
                      />
                      <path class="cls-2" d="M 11.553211,7.9033098 V 6.2251187 h 0.555648 l 0.01502,1.6781921 z" />
                    </g>
                  </svg>`,
    market: `<svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <g  transform="scale(0.5 0.5) translate(12 5)">
                    <path fill="#FFF" d="M6,16.5L3,19.44V11H6M11,14.66L9.43,13.32L8,14.64V7H11M16,13L13,16V3H16M18.81,12.81L17,11H22V16L20.21,14.21L13,21.36L9.53,18.34L5.75,22H3L9.47,15.66L13,18.64" />
                  </g>
                </svg>`,
    biomass: `<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 26 26">
                <defs>
                  <style>
                  .cls-1-biomass {
                    fill:  #FFF;
                  }
                  </style>
                </defs>
              <g transform="scale(0.4, 0.4) translate(19.5, 11.5)">
                <path class="cls-1-biomass"  d="M 6.8125 0 A 1.001098 1.001098 0 0 0 7 2 L 8 2 L 8 4.84375 C 7.9979712 4.8612892 7.9918849 4.9347403 7.96875 5 C 7.9224802 5.1305194 7.8544733 5.3502899 7.75 5.59375 C 7.5410534 6.0806702 7.216187 6.7475804 6.84375 7.53125 C 6.0988759 9.0985892 5.09548 11.121432 4.09375 13.1875 C 3.09202 15.253568 2.104054 17.367226 1.34375 19.09375 C 0.96359801 19.957012 0.63805546 20.704215 0.40625 21.34375 C 0.17444454 21.983285 0 22.416667 0 23 C 0 23.666667 0.19262616 24.305698 0.5625 24.78125 C 0.93237384 25.256802 1.4360089 25.520336 1.9375 25.6875 C 2.9404822 26.021827 4 26 5 26 L 21 26 C 22 26 23.059518 26.02183 24.0625 25.6875 C 24.563991 25.520336 25.067626 25.256802 25.4375 24.78125 C 25.807374 24.305698 26 23.666667 26 23 C 26 22.416667 25.825555 21.983285 25.59375 21.34375 C 25.361945 20.704215 25.036402 19.957012 24.65625 19.09375 C 23.895946 17.367226 22.90798 15.253568 21.90625 13.1875 C 20.90452 11.121432 19.901124 9.0985892 19.15625 7.53125 C 18.783813 6.7475804 18.458947 6.0806702 18.25 5.59375 C 18.145527 5.3502899 18.07752 5.1305194 18.03125 5 C 18.008115 4.9347403 18.002029 4.8612892 18 4.84375 L 18 2 L 19 2 A 1.0001 1.0001 0 1 0 19 0 L 7 0 A 1.0001 1.0001 0 0 0 6.90625 0 A 1.001098 1.001098 0 0 0 6.8125 0 z M 10 2 L 16 2 L 16 5 C 16 5.3958333 16.08533 5.487453 16.15625 5.6875 C 16.22717 5.887547 16.323223 6.1086945 16.4375 6.375 C 16.666053 6.9076111 16.966187 7.5805446 17.34375 8.375 C 18.098876 9.9639108 19.09548 12.003568 20.09375 14.0625 C 21.09202 16.121432 22.104054 18.195274 22.84375 19.875 C 23.213598 20.714863 23.513055 21.463753 23.71875 22.03125 C 23.924445 22.598747 24 23.083333 24 23 C 24 23.333333 23.94263 23.444302 23.875 23.53125 C 23.80737 23.6182 23.686009 23.729664 23.4375 23.8125 C 22.940482 23.978173 22 24 21 24 L 5 24 C 4 24 3.0595178 23.978173 2.5625 23.8125 C 2.3139911 23.729664 2.1926262 23.618198 2.125 23.53125 C 2.0573738 23.444302 2 23.333333 2 23 C 2 23.08333 2.075556 22.598747 2.28125 22.03125 C 2.4869445 21.463753 2.786402 20.714863 3.15625 19.875 C 3.895946 18.195274 4.90798 16.121432 5.90625 14.0625 C 6.90452 12.003568 7.9011241 9.9639108 8.65625 8.375 C 9.033813 7.5805446 9.3339466 6.9076111 9.5625 6.375 C 9.6767767 6.1086945 9.7728323 5.887547 9.84375 5.6875 C 9.9146677 5.487453 10 5.3958333 10 5 L 10 2 z M 13.40625 10.5 C 12.60625 10.8 11.2 12.00625 10.5 13.90625 C 11.5 14.30625 12.3 14.8875 13 15.6875 C 13.7 14.9875 14.5125 14.4 15.3125 14 C 15.0125 12.6 14.20625 11.3 13.40625 10.5 z M 7.5 14 C 7 15 6.59375 18.0125 8.59375 20.3125 C 9.29375 21.1125 10.19375 21.6125 11.09375 21.8125 C 10.99375 19.5125 11.50625 17.8 12.40625 16.5 C 11.00625 14.9 9 14.2 7.5 14 z M 18.5 14 C 15.8 14.3 11.69375 16.20625 12.09375 21.90625 C 12.09375 21.90625 15.5 22.5125 17.5 20.3125 C 19.4 18.0125 19.1 15 18.5 14 z"/>
              </g>
            </svg>`,
    gas: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path  transform="scale(0.6 0.6) translate(8 4)" fill="#FFF" d="M17.66 11.2C17.43 10.9 17.15 10.64 16.89 10.38C16.22 9.78 15.46 9.35 14.82 8.72C13.33 7.26 13 4.85 13.95 3C13 3.23 12.17 3.75 11.46 4.32C8.87 6.4 7.85 10.07 9.07 13.22C9.11 13.32 9.15 13.42 9.15 13.55C9.15 13.77 9 13.97 8.8 14.05C8.57 14.15 8.33 14.09 8.14 13.93C8.08 13.88 8.04 13.83 8 13.76C6.87 12.33 6.69 10.28 7.45 8.64C5.78 10 4.87 12.3 5 14.47C5.06 14.97 5.12 15.47 5.29 15.97C5.43 16.57 5.7 17.17 6 17.7C7.08 19.43 8.95 20.67 10.96 20.92C13.1 21.19 15.39 20.8 17.03 19.32C18.86 17.66 19.5 15 18.56 12.72L18.43 12.46C18.22 12 17.66 11.2 17.66 11.2M14.5 17.5C14.22 17.74 13.76 18 13.4 18.1C12.28 18.5 11.16 17.94 10.5 17.28C11.69 17 12.4 16.12 12.61 15.23C12.78 14.43 12.46 13.77 12.33 13C12.21 12.26 12.23 11.63 12.5 10.94C12.69 11.32 12.89 11.7 13.13 12C13.9 13 15.11 13.44 15.37 14.8C15.41 14.94 15.43 15.08 15.43 15.23C15.46 16.05 15.1 16.95 14.5 17.5H14.5Z" />
        </svg>`,
    oil: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path transform="scale(0.5 0.5) translate(12 7)" fill="#FFF" d="M20 13C20.55 13 21 12.55 21 12S20.55 11 20 11H19V5H20C20.55 5 21 4.55 21 4S20.55 3 20 3H4C3.45 3 3 3.45 3 4S3.45 5 4 5H5V11H4C3.45 11 3 11.45 3 12S3.45 13 4 13H5V19H4C3.45 19 3 19.45 3 20S3.45 21 4 21H20C20.55 21 21 20.55 21 20S20.55 19 20 19H19V13H20M12 16C10.34 16 9 14.68 9 13.05C9 11.75 9.5 11.38 12 8.5C14.47 11.36 15 11.74 15 13.05C15 14.68 13.66 16 12 16Z" />
          </svg>`,
    jetFuel: `<g transform="scale(0.8 0.8) translate(3.0 1.0)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path  fill="none" stroke="#fff" d="M12,20A6,6 0 0,1 6,14C6,10 12,3.25 12,3.25C12,3.25 18,10 18,14A6,6 0 0,1 12,20Z" />
            </svg>
            <g transform="translate(0 1.5)">
            <svg viewBox="0 0 24 24">
                <path transform="rotate(-45, 12, 12) scale(0.45 0.45) translate(16.5 12.5)"  fill="#fff" d="M20.56 3.91C21.15 4.5 21.15 5.45 20.56 6.03L16.67 9.92L18.79 19.11L17.38 20.53L13.5 13.1L9.6 17L9.96 19.47L8.89 20.53L7.13 17.35L3.94 15.58L5 14.5L7.5 14.87L11.37 11L3.94 7.09L5.36 5.68L14.55 7.8L18.44 3.91C19 3.33 20 3.33 20.56 3.91Z" />
            </svg>
            </g>
            </g>`,
    coal: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" >
            <defs>
              <style>
              .cls-1-coal {
                fill:  #fff;
                stroke-width: 1;
                stroke: #fff;
              }
              .cls-2-coal {
                fill:  #fff;
                stroke-width: 0;
                stroke: #fff;
              }
              .coal-wheel {
                fill: #fff;
                stroke: #306d8a;
                stroke-width: 0.8;
              }
              </style>
            </defs>
            <g transform="scale(0.55 0.55) translate(9.8 4)">
              <line class="cls-1-coal" x1="2" y1="12" x2="22" y2="12" />
              <polygon class="cls-1-coal" points="3,12 7,20 17,20 21,12"/>
              <circle class="coal-wheel" cx="8" cy="20" r="3"/>
              <circle class="coal-wheel" cx="16" cy="20" r="3"/>
              <polygon class="cls-2-coal" points="4,10.7 5,9 6.5,9 8,6.5 9.5,7 11,5 14,7 16,7 17,8.7 18.5,8.7 20,10.7"/>
            </g>
          </svg>`,
    uranium: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path  transform="scale(0.5 0.5) translate(12 6)" fill="#fff" d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 10C13.11 10 14 10.9 14 12S13.11 14 12 14 10 13.11 10 12 10.9 10 12 10M4 12C4 8.7 6 5.87 8.86 4.64L10.34 8.36C8.96 9 8 10.38 8 12H4M12 20C10.46 20 9 19.56 7.8 18.8L10 15.47C10.6 15.81 11.28 16 12 16S13.4 15.81 14 15.47L16.2 18.8C15 19.56 13.54 20 12 20M16 12C16 10.38 15.04 9 13.66 8.36L15.15 4.64C18 5.87 20 8.7 20 12H16Z" />
              </svg>`,
    diesel: ` <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path transform="scale(0.5 0.5) translate(12 9)" fill="#fff" d="M3,2H6C6.28,2 6.53,2.11 6.71,2.29L8.79,4.38L9.59,3.59C10,3.2 10.5,3 11,3H17C17.5,3 18,3.2 18.41,3.59L19.41,4.59C19.8,5 20,5.5 20,6V19A2,2 0 0,1 18,21H8A2,2 0 0,1 6,19V13L6,12V8C6,7.5 6.2,7 6.59,6.59L7.38,5.79L5.59,4H3V2M11,5V7H17V5H11M11.41,11L9.41,9H8V10.41L10,12.41V15.59L8,17.59V19H9.41L11.41,17H14.59L16.59,19H18V17.59L16,15.59V12.41L18,10.41V9H16.59L14.59,11H11.41M12,13H14V15H12V13Z" />
              </svg>`,
  };
  return iconShapes[iconName];
};

const customIcon = (iconName) => {
  const pinFillColor = "#306d8a";
  const pinBorderColor = pinFillColor;
  return divIcon({
    className: "my-custom-pin",
    html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="48px" width="48px">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                  fill="${pinFillColor}"
                  stroke="${pinBorderColor}"/>
                ${getIcon(iconName, pinFillColor)}
              </svg>`,
    iconAnchor: [24, 44],
  });
};

const generatorIconName = (generator) => {
  if (generator.type === "THERMAL") {
    if (generator.source.includes("GAS")) return "gas";
    if (generator.source.includes("OIL")) return "oil";
    if (generator.source === "BIOMASS") return "biomass";
    if (generator.source === "JET_FUEL") return "jetFuel";
    if (generator.source === "COAL") return "coal";
    if (generator.source === "URANIUM") return "uranium";
    if (generator.source === "GEOTHERMAL") return "geothermal";
    if (generator.source.includes("DIESEL")) return "diesel";
    return "thermal";
  }
  return {
    SOLAR_PV: "solar",
    WIND: "wind",
    HYDRO: "hydro",
    GEOTHERMAL: "geothermal",
  }[generator.source];
};

const circleIcon = (iconName, color, stroke = "#90D7EC", strokeWidth = 1) => {
  return divIcon({
    className: "my-custom-pin",
    html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="48px" width="48px">
            <circle cx=12 cy=10 r=8 fill="${color}" stroke="${stroke}" stroke-width="${strokeWidth}"/>
            ${getIcon(iconName, color)}
            </svg>`,
    iconAnchor: [24, 21],
  });
};

const svgShape = (shape, stroke, fill) => {
  const svgTag = '<svg width="12" height="12" version="1.1" xmlns="http://www.w3.org/2000/svg">';
  const circle = `<circle cx="6" cy="6" r="4" stroke="${stroke}" fill="${fill}" stroke-width="1"/>`;
  const square = `<rect x="1" y="1" width="10" height="10" stroke="${stroke}" fill="${fill}" stroke-width="1"/>`;
  const triangle = `<polygon points="6,1 0,11 11,11" stroke="${stroke}" fill="${fill}" stroke-width="1"/>`;
  const svgEndTag = "</svg>";

  const shapes = {
    circle,
    square,
    triangle,
  };

  return divIcon({
    className: "case-icon",
    html: svgTag + shapes[shape] + svgEndTag,
    iconAnchor: [6, 6],
    iconSize: [12, 12],
  });
};

export { svgShape, circleIcon, customIcon, getIcon, generatorIconName };
